import jwt_decode from 'jwt-decode';

export interface IDecodedToken {
    sub: string;
    jti: string;
    iat: number;
    rol: string;
    id: string;
    ten: string;
    per: string[];
    nbf: number;
    exp: number;
    iss: string;
    aud: string;
    support: string;
    client_id: string;
}

export class AadToken {
    public static parse(jwtToken: string): AadToken {
        const decoded: any = jwt_decode(jwtToken);
        return new AadToken(decoded.iss, new Date(decoded.exp), decoded.preferred_username, decoded.aud, decoded.tid);
    }
    private constructor(public issuer: string, public expiresAt: Date, public preferredUsername: string, public audience: string, public tenantId: string) {

   }
}

export class Token {
    constructor(public encoded: string) { }

    private static readonly EPOCH_TO_UNIX_TIME_FACTOR: number = 1000;

    get decoded(): IDecodedToken { return this.encoded ? jwt_decode(this.encoded) : null; }
    get isExpired(): boolean { return !!this.decoded ? new Date(this.decoded.exp * Token.EPOCH_TO_UNIX_TIME_FACTOR) < new Date() : true; }
}

export class Identity {
    constructor(public userId: string) { }

    public name: string;
}

export class Principal {
    constructor(public token: Token) { }

    get userId(): string { return !!this.token && !!this.token.decoded ? this.token.decoded.id : null; }
    get tenantId(): string { return !!this.token && !!this.token.decoded ? this.token.decoded.ten : null; }
    get isAuthenticated(): boolean { return !!this.token; }
}
